<template>
    <div>
        <span>{{ $_.get(activity, 'actorUser.name') || 'Bilinmeyen Kullanıcı' }} kullanıcısı "{{ $_.get(activity, 'payload.taskTitle') || $_.get(activity, 'payload.name') || 'Bilinmeyen Görev' }}" adlı görevi çöp kutusundan geri çıkardı.</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskRestored",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>
<style scoped lang="scss"></style>

